import { DietaryProfile } from '@/types/dietary-profile';
import { DietaryProfileWire } from '../schemas/dietary-profile';

/**
 * Convert wire dietary-profile format (backend) to domain format (app).
 * Handles type conversions: ISO strings -> Unix ms, 0/1 -> boolean,
 * null -> undefined. Returns a new object; never mutates the input.
 */
export function mapDietaryProfileWireToDomain(wire: DietaryProfileWire): DietaryProfile {
  return {
    id: wire.id,
    name: wire.name,
    slug: wire.slug,
    description: wire.description ?? undefined, // Convert null to undefined
    isCurated: wire.is_curated === 1,
    createdAt: new Date(wire.created_at).getTime(),
    updatedAt: new Date(wire.updated_at).getTime(),
  };
}
